<template>
  <div ref="trendLine" class="trend-line-report-section">
    <h5 class="data-title text-center">
      <span class="selected-data-type" @click.stop="toggleRecipientDropdown">
        <group-names
            v-if="hasFilters"
            :groups="onlySelectedGroups"
            hideGroupName
            isOnlySelected>
        </group-names>
        <template v-if="!hasFilters">all</template>
      </span>
      customers
    </h5>

    <recipient-dropdown
      v-if="groupsWithSelected"
      :hide-preview="true"
      :show-subtext="false"
      :groups-with-selected="groupsWithSelected"
      :trigger-focused.sync="triggerFocused"
      @update:selected="setSelectedGroups"
      class="recipient-filter"
      data-cy="recipient-filter-button"
    />

    <select-by-type
        :customSelected="metric"
        textBeforeSelected=""
        textAfterSelected="by time"
        @setDataType="setReportDataType">
    </select-by-type>

    <div v-if="errorText" v-html="errorText" class="error-label text-center">{{errorText}}</div>

    <line-graph
        v-if="graphData && wrapperWidth && !errorText"
        :graphData="graphData"
        :toolTipContent="toolTipContent"
        :wrapperWidth="wrapperWidth"
        xSelector="date_time"
        ySelector="amount"
        @setToolTipContent="setToolTipContent">
    </line-graph>
  </div>
</template>

<script>
  import GroupsDropDown from '../GroupWidget/GroupsDropDown'
  import GroupNames from '../GroupWidget/GroupNames'
  import LineGraph from '../Graphs/LineGraph'
  import ReportsMixin from '../../mixins/ReportsMixin'
  import SelectByType from './SelectByType'
  import ToolTipContentMixin from '../../mixins/ToolTipContentMixin'
  import RecipientDropdown from '../Campaigns/recipient-dropdown.vue';
  import { groupsAPI } from "../../services/api/groupsAPI";

  export default {
    props: {
      error: String,
      graphData: Array,
      isTracked: Boolean,
      wrapperWidth: [Number, String],
    },

    name: 'TrendLineReport',

    components: {
      GroupsDropDown,
      GroupNames,
      LineGraph,
      SelectByType,
      RecipientDropdown
    },

    mixins: [ReportsMixin, ToolTipContentMixin],

    data() {
      return {
        baseErrorMessage: 'could not load selected filters',
        errorMessage: null,
        graphParams: null,
        groupsWithSelected: null,
        merchantSegmentIds: null,
        merchantTagIds: null,
        openGroupItem: null,
        sectionOpen: false,
        slideDown: false,
        toolTipContent: null,
        triggerFocused: false,
      }
    },

    methods: {
      loadGraphData() {
        const params = {
          metric: this.metric
        };

        if (this.merchantSegmentIds?.length) {
          params.segment_ids = this.merchantSegmentIds;
        }
        if (this.merchantTagIds?.length) {
          params.merchant_tag_ids = this.merchantTagIds;
        }
        this.graphParams = { params };
        this.$emit('loadGraphData', 'trendline', 'trends', { params })
      },

      async loadSelectedGroups() {
        const groups = await groupsAPI.getGroups(this.merchantSegmentIds, this.merchantTagIds);

        if(groups) {
          this.groupsWithSelected = groups;
        }else{
          this.errorMessage = `${this.baseErrorMessage}: ${error}`;
        }
      },

      setReportDataType(dataType) {
        if (this.reportDataType !== dataType) {
          this.reportDataType = dataType
          this.loadGraphData()
        }
      },

      setSelectedGroups(frag) {
        if(frag.merchant_segment_ids){
          this.merchantSegmentIds = frag.merchant_segment_ids;
        }
        if(frag.merchant_tag_ids){
          this.merchantTagIds = frag.merchant_tag_ids;
        }
        this.loadGraphData()
        this.loadSelectedGroups()
      },

      setToolTipContent(item) {
        this.toolTipContent = this.getToolTipContent(item, 'trends')
      },

      toggleRecipientDropdown() {
        this.triggerFocused = !this.triggerFocused;
      }
    },

    created() {
      this.loadGraphData()
      this.loadSelectedGroups()
    },

    computed: {
      errorText() {
        const hasMulti = !!this.error && !!this.errorMessage
        return hasMulti ? `${this.error} <br /> ${this.errorMessage}` : this.error ? this.error : this.errorMessage
      },

      hasFilters() {
        return this.merchantSegmentIds?.length ||  this.merchantTagIds?.length
      },

      onlySelectedGroups(){
        return this.groupsWithSelected ? this.groupsWithSelected.groups_with_selected.filter((group) => !!group.display_names) : null
      }
    },
  }
</script>

<style scoped>
.recipient-filter {
  border: none;
  z-index: 11;
}
.recipient-filter >>> .label-container{
  display: none;
}
.recipient-filter >>> .sb-content {
  min-width: unset;
  max-width: 256px;
}
</style>
